import autosize from 'autosize';
import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/project-infos.scss';

Component('tr-project-infos', {
  mixins: [eventListenerMixin],

  properties: {
    editUrl: String,
    arrangementDirection: String,
  },

  ready() {
    this.initDescField();
    this.initAssigneeSelectField();
    this.initPrioritySelectField();
    this.initDateSelectField();
    this.listenTo(this, 'tr-project-progress-custom-field:change', this.handleCustomFieldChange.bind(this));
  },

  layout() {
    const descText = this.querySelector('.desc-field .desc');
    const isEmptyDesc = $('.desc-field').hasClass('empty');
    if (!isEmptyDesc) {
      const input = this.querySelector('.desc-field textarea');
      input.style.display = 'block';
      autosize.update(input);
    }
    descText.style.display = 'none';
  },

  initDescField() {
    const descField = this.querySelector('.desc-field');
    const input = descField.querySelector('textarea');
    const originalContent = input.value;
    autosize(input);
    this.listenTo(descField.querySelector('.field-content'), 'click', () => {
      descField.classList.remove('empty');
      descField.classList.add('editing');
      input.focus();
      autosize.update(input);
    });
    this.listenTo(input, 'blur', () => {
      descField.classList.remove('editing');
      input.style.display = 'block';
      if (!input.value) descField.classList.add('empty');
      if (input.value !== originalContent) {
        this.submitData({ desc: input.value });
      }
    });
    this.listenTo(input, 'keydown', (event) => {
      descField.classList.remove('empty');
      if (event.code === 'Enter' || event.code === 'Escape') {
        input.blur();
      }
    });
  },

  initDateSelectField() {
    this.dateField = this.querySelector('tr-todo-date-field');
    this.listenTo(this.dateField, 'tao:change', (event) => {
      const [startAt, endAt] = this.parseDate(event.detail.split(','));
      this.submitData({ start_at: startAt, end_at: endAt });
    });
  },

  parseDate(dates) {
    let startAt;
    let endAt;
    if (dates.length === 2) {
      [startAt, endAt] = dates;
    } else {
      startAt = null;
      [endAt] = dates;
    }
    return [startAt, endAt];
  },

  initAssigneeSelectField() {
    this.selectorField = this.querySelector('.assignee-select-field tr-selector-field');
    this.listenTo(this.selectorField, 'tao:change', (event) => {
      this.submitData({ assignee_id: event.detail });
    });
  },

  initPrioritySelectField() {
    this.selectorField = this.querySelector('.priority-select-field tr-selector-field');
    this.listenTo(this.selectorField, 'tao:change', (event) => {
      this.submitData({ priority: event.detail });
    });
  },

  handleCustomFieldChange(event) {
    event.stopPropagation();

    const fieldKey = event.target.key;
    let data = { [fieldKey]: event.detail };

    const isMultipleSelect = !!event.target.querySelector('tr-multiple-select-field');
    if (isMultipleSelect && event.detail.length === 0) {
      data = { [`${fieldKey}[]`]: '' };
    }

    this.submitData({ custom_field_value: data });
  },

  submitData(data) {
    const dataType = this.arrangementDirection === 'horizontal' ? 'json' : 'script';
    $.ajax({
      url: this.editUrl,
      type: 'put',
      dataType,
      data,
    });
  },
});
